/**
 * Серверийн (Vultr) кредит — толгой мөрийн pill, ЗӨВХӨН ADMIN (2026-11-03).
 * Hero туузан дээр цасан зурагт уусаж харагдахгүй байсан тул энд шилжив.
 *
 * ⚠️ Эрхийн жинхэнэ хамгаалалт backend дээр (`setupSystem.manage`).
 *    `VULTR_API_KEY` тавиагүй бол юу ч харуулахгүй.
 */

import { useQuery } from '@tanstack/react-query';
import { formatDate, formatRate, type HostingBalance } from '@boots/domain';
import { api, type Envelope } from '../lib/api';

export function HostingBalancePill() {
  const q = useQuery({
    queryKey: ['hosting-balance'],
    queryFn: () => api<Envelope<HostingBalance>>('/system/hosting/balance'),
    // Сервер талд 1 цагийн cache бий
    staleTime: 60 * 60 * 1000,
    retry: false,
  });

  const b = q.data?.data;
  if (!b?.configured) return null;
  const r = b.runway;
  const alert = r?.level === 'low' || r?.level === 'out';

  const title = r?.runsOutOn
    ? `Vultr кредит ${formatDate(r.runsOutOn)} хүртэл хүрнэ${alert ? ' — цэнэглэ' : ''}`
    : (b.error ?? 'Vultr кредит');

  return (
    <span
      className={`hidden items-center gap-2 rounded-full border px-4 py-2 text-[13px] font-semibold md:flex ${
        alert ? 'border-alert/30 bg-alert-bg text-alert-ink' : 'border-accent-300 bg-accent-100 text-accent-700'
      }`}
      title={title}
    >
      Сервер ·{' '}
      {r ? (
        <span className="num">
          ${formatRate(r.creditUsd)}
          {r.level === 'out' ? ' · дууссан' : r.daysLeft !== null ? ` · ${r.daysLeft} хоног` : ''}
        </span>
      ) : (
        'боломжгүй'
      )}
    </span>
  );
}
